import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@autoinject
@customElement('edit5')
export class Edit5CustomElement extends BaseCustomElement {
}